/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_First_Meeting_KickerInputs */



/**
* | output |
* | --- |
* | "Your first conversation" |
*
* @param {Onboarding_First_Meeting_KickerInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const onboarding_first_meeting_kicker = /** @type {((inputs?: Onboarding_First_Meeting_KickerInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_First_Meeting_KickerInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je eerste gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre première conversation")
	return /** @type {LocalizedString} */ ("Your first conversation")
});